export default __webpack_public_path__ + "static/media/logo_marino_bus.157dd539.svg";